import { Dispatch } from 'redux';
import { AnyComponentStructure } from '@start-set/wakadoo-editor-core/Types';
import store from '../store/store';
import {
	setCloseTableModalFunc,
	setCreateModuleWindowClose,
	setCreateTableFunc,
	setIsCreateTableModalOpen, moduleWindowActions,
} from '../../entities/module/private-template-module/model/slice';
import {
	createWorkshopModuleActions,
} from '../../features/manage-workshop-module/model/create-module/slice/createWorkshopModuleSlice';
import { workshopModuleActions } from '../../entities/module/workshop-module';
import { templateModuleActions } from '../../entities/template-module';
import {
	setAiMode,
	setIsAiCategoriesModalOpen,
} from '../../features/ai/model/slice/aiSlice';

// * Вызов модалки AI
export const onOpenAIActionsModal = () => {
	requestAnimationFrame(() => {
		store.dispatch(setIsAiCategoriesModalOpen(true));
		store.dispatch(setAiMode(true));
	});
};

export const onCloseAIActionsModal = () => {
	requestAnimationFrame(() => {
		store.dispatch(setIsAiCategoriesModalOpen(false));
		store.dispatch(setAiMode(false));
	});
};

export const onCloseModuleWindow = () => {
	// store.dispatch(setWindowModuleClose());
	// store.dispatch(templateModuleActions.setIsTemplateModuleActive(false));
};

// * Вызов модалки модулей шаблонов
export const onOpenTemplateModuleWindow = (
	onEntityModuleClick: (moduleId: string) => void,
	onGalleryModuleClick: (moduleId: string) => void,
	onCloseModuleWindow: () => void,
) => {
	// store.dispatch(templateModuleActions.setOnEntityModuleClick(onEntityModuleClick));
	store.dispatch(templateModuleActions.setOnGalleryModuleClick(onGalleryModuleClick));

	store.dispatch(templateModuleActions.setCloseModuleModalFunc(onCloseModuleWindow));

	// store.dispatch(templateModuleActions.setIsTemplateModuleActive(true));
};

// * Вызов модалки модулей мастерской
export const onOpenWorkshopModuleWindow = (
	onModuleClick: (moduleId: string) => void,
	onCloseModuleWindow: () => void,
) => {
	store.dispatch(workshopModuleActions.setModuleFunc(onModuleClick));

	store.dispatch(workshopModuleActions.setCloseModuleModalFunc(onCloseModuleWindow));

	// store.dispatch(workshopModuleActions.setIsModulesModalActive(true));
};

export const onThunkCloseCreateModuleWindow = () => (dispatch: Dispatch) => {
	dispatch(setCreateModuleWindowClose());
};

// * Вызов модалки создания таблицы
export const onOpenCreateTableWindow = (
	onCreateTable: (columnCount: number, rowCount: number) => void,
	onCloseTableModal: () => void,
) => {
	store.dispatch(setIsCreateTableModalOpen(true));
	store.dispatch(setCreateTableFunc(onCreateTable));
	store.dispatch(setCloseTableModalFunc(onCloseTableModal));
};
